import React, { useEffect, useRef, useState } from "react";
import "./FormInputField.scss";

import { IoMailOutline } from "react-icons/io5";
import { AiOutlineLock } from "react-icons/ai";
import { AiOutlineUnlock } from "react-icons/ai";
import { RiMessageLine } from "react-icons/ri";

import { FaRegEye } from "react-icons/fa";
import { FaRegEyeSlash } from "react-icons/fa";

import { useClickOutside } from "use-events";

const FormInputField = ({
  name,
  type,
  label,
  register,
  required,
  watch,
  constraints,
  iconType,
  inputErrors,
}) => {
  const [inputType, setInputType] = useState(type);

  const inputRef = useRef(null);
  const [active, setActive] = useState(false);

  const inputWatch = watch(name);

  const handleBlur = () => {
    if (inputWatch === "") {
      setActive(false);
    }
  };

  useEffect(() => {
    if (inputWatch === "" || inputWatch === null) {
      setActive(false);
    } else {
      setActive(true);
    }
  }, [inputWatch]);

  const handleFocus = () => {
    setActive(true);
  };

  useClickOutside([inputRef], (event) => {
    handleBlur();
  });
  return (
    <div className={`form-input-field ${active ? "active" : ""}`} ref={inputRef}>
      <label className={active ? "active" : ""} htmlFor={name}>
        {label}
      </label>
      <p className="front-icon">
        {iconType === "email" && <IoMailOutline />}
        {iconType === "password" && inputType === "password" && (
          <AiOutlineLock />
        )}
        {iconType === "password" && inputType === "text" && <AiOutlineUnlock />}
        {iconType === "sms" && <RiMessageLine />}
      </p>
      <input
        autoComplete={`new-${name}`}
        onFocus={handleFocus}
        onBlur={handleBlur}
        step={"any"}
        type={inputType}
        {...register(name, { required: required, ...constraints })}
      />
      <p className="rare-icon">
        {iconType === "password" && inputType === "password" && (
          <FaRegEye
            onClick={() => {
              setInputType("text");
            }}
          />
        )}
        {iconType === "password" && inputType === "text" && (
          <FaRegEyeSlash
            onClick={() => {
              setInputType("password");
            }}
          />
        )}
      </p>
      {inputErrors[name]?.type && (
        <p className="error">
          {inputErrors[name].type === "custom"
            ? inputErrors[name].message
            : inputErrors[name].type === "required"
            ? `${name} field is required.`
            : inputErrors[name]?.message || `${name} input is not valid.`}
        </p>
      )}
    </div>
  );
};

export default FormInputField;
